import React from 'react';

export default function TelegramGateway() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Telegram Gateway</h1>
      <p className="text-gray-500">Halaman Telegram Gateway</p>
    </div>
  );
}
